module.exports = __webpack_public_path__ + "media/images/logo_print-dc5d87570821d406a2e2c926160792bb.png";